import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import ModalButton from 'components/CustomButtons/Button';
import Close from '@material-ui/icons/Close';
import Moneybox from 'views/Clients/FormTabs/Moneybox/Moneybox';
import { get } from 'helpers/apiHelpers';
import makeStyles from '@material-ui/styles/makeStyles';

const useStyles = makeStyles({
  dialog: {
    maxHeight: '700px',
  },
  modalCloseButton: {
    position: 'absolute',
    top: '0',
    right: '0',
    cursor: 'pointer',
  },
});

const DietDetailsMoneybox = ({
  isOpenModal,
  setIsOpenModal,
  client,
  setClient,
}) => {
  const classes = useStyles();

  const closeModal = async () => {
    const updatedClient = await get(client['@id']);
    setClient(updatedClient);
    setIsOpenModal(false);
  };

  return (
    <Dialog
      maxWidth="lg"
      fullWidth={true}
      open={isOpenModal}
      onClose={closeModal}
    >
      <DialogContent className={classes.dialog}>
        <ModalButton
          className={classes.modalCloseButton}
          color="transparent"
          justIcon={true}
          round={true}
          onClick={closeModal}
        >
          <Close />
        </ModalButton>
        <Moneybox
          userId={client.id}
          userMoneybox={client.moneyBox}
          noCancel={true}
        />
      </DialogContent>
    </Dialog>
  );
};

export default DietDetailsMoneybox;
